import { TCModel, TCString } from '@iabtcf/core';
import * as Logger from './logger';

/**
 * Helper that decodes a TCString into a TCModel and verifies the result.
 * @param encodedTcString
 */
export function decodeTCString(encodedTcString: string): TCModel {
  let tcModel: TCModel;
  try {
    tcModel = TCString.decode(encodedTcString);
  } catch (ex) {
    Logger.error('decodeTCString: Could not decode tcString into tcModel, tcString is invalid!');
    return null;
  }

  if (!tcModel ||
    !tcModel.publisherConsents ||
    !tcModel.purposeConsents ||
    !tcModel.vendorConsents ||
    !tcModel.specialFeatureOptins) {
    Logger.error('decodeModel: Decoded model is invalid!');
    return null;
  }

  return tcModel;
}
